export function structureCondition(id) {
  return `
        <div class="weiche-node">
            <div class="title-box">
                <div class="title-text"><i class="bi bi-signpost-split"></i> Bedingung / Weiche</div>
                <button type="button" class="btn-node-delete" title="Element entfernen" aria-label="Element entfernen"><i class="bi bi-x-lg"></i></button>
            </div>
            <hr>
            <div class="content-box">
                <p class="small text-muted mb-2">Prüft die vorherige Antwort und leitet automatisch weiter:</p>
                <div class="row">
                    <div class="form-group col-6">
                        <label class="col-12">Operator</label>
                        <div class="col-12">
                            <select class="form-select form-select-sm" df-operator>
                                <option value="gte" selected>≥ (Größer gleich)</option>
                                <option value="gt">> (Größer als)</option>
                                <option value="lte">≤ (Kleiner gleich)</option>
                                <option value="lt">< (Kleiner als)</option>
                                <option value="eq">= (Gleich)</option>
                                <option value="neq">≠ (Ungleich)</option>
                                <option value="contains">Enthält Text</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group col-6">
                        <label class="col-12">Vergleichswert</label>
                        <div class="col-12">
                            <input type="text" class="form-control form-control-sm" df-value value="4" placeholder="z. B. 4 oder Ja">
                        </div>
                    </div>
                </div>
                <div class="weiche-outputs-info mt-2 pt-2 border-top">
                    <div class="d-flex justify-content-between align-items-center small py-1">
                        <span class="text-success fw-bold"><i class="bi bi-check-circle-fill me-1"></i> Ausgang 1:</span>
                        <span class="badge bg-success-subtle text-success">Bedingung erfüllt (JA)</span>
                    </div>
                    <div class="d-flex justify-content-between align-items-center small py-1">
                        <span class="text-secondary fw-bold"><i class="bi bi-x-circle-fill me-1"></i> Ausgang 2:</span>
                        <span class="badge bg-secondary-subtle text-secondary">Sonst / Fallback (NEIN)</span>
                    </div>
                </div>
            </div>
        </div>`;
}
